

export default function IframeDashURL(props) {

    return (
        <div className="flex w-full h-full">
            <iframe className="h-screen" allowFullScreen={true} src={props.URL} scrolling="yes"></iframe>
        </div>
    )
}